import { createStyles, makeStyles } from "@material-ui/styles";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    LogoOnly,
    RelodeTheme,
    Text,
    useMediator,
} from "@relode/core";
import * as React from "react";

import { JobManagerContact } from "../../types";
import { JobManagerContactDetails } from "../candidate";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                display: "flex",
                flexGrow: 1,
                flexDirection: "column",
            },
            logo: {
                marginBottom: theme.spacing(2),
                width: 64,
                height: 64,
            },
            title: {
                marginBottom: theme.spacing(2),
            },
            aeContact: {
                margin: "auto",
            },
            header: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
                margin: theme.spacing(4, 0),
            },
        }),
    { name: "AddNewJobConfirmationDialog" }
);

export const AddNewJobConfirmationDialog = () => {
    const classes = useStyles({});
    const [jobId, setJobId] = React.useState(undefined);
    const [jobName, setJobName] = React.useState(undefined);
    const [jobManagerContact, setJobManagerContact] =
        React.useState<JobManagerContact>(undefined);
    const [isOpen, setIsOpen] = React.useState(false);

    useMediator("showAddNewJobConfirmation", data => {
        setJobId(data?.jobId);
        setJobName(data?.jobName);
        setJobManagerContact(data?.jobManagerContact);
        setIsOpen(true);
    });

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <Dialog open={isOpen} onClose={handleClose}>
            <DialogTitle title="" onClose={handleClose} />
            <DialogContent>
                <div className={classes.header}>
                    <LogoOnly className={classes.logo} />
                    <Text variant="h2" className={classes.title}>
                        hooray!
                    </Text>
                    <Text variant="body1">
                        Your job is being processed! Your Relode job manager
                        will reach out to you if there are any questions.
                    </Text>
                </div>
                <Divider />
                <JobManagerContactDetails
                    className={classes.aeContact}
                    jobManagerContact={jobManagerContact}
                    contactActionVariant="button"
                    jobId={jobId}
                    jobName={jobName}
                />
            </DialogContent>
        </Dialog>
    );
};
